import { render } from "./VariablesView.vue?vue&type=template&id=4c24c670&scoped=true&ts=true"
import script from "./VariablesView.vue?vue&type=script&lang=ts"
export * from "./VariablesView.vue?vue&type=script&lang=ts"

import "./VariablesView.vue?vue&type=style&index=0&id=4c24c670&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c24c670"]])

export default __exports__